import script from "./InputText.vue?vue&type=script&setup=true&lang=js"
export * from "./InputText.vue?vue&type=script&setup=true&lang=js"

import "./InputText.vue?vue&type=style&index=0&id=676dc242&lang=scss"

const __exports__ = script;

export default __exports__